import { WHITELIST } from './apiModules'

import { post } from '@/utils/request'

export function getWhitelist(params) {
  return post(`${WHITELIST}/list`, params)
}

export function getBehaviorList(params) {
  return post(`${WHITELIST}/orgWhiteListMessage/list`, params)
}

export function getOrgInfo(params) {
  return post(`${WHITELIST}/orgInfo`, params)
}

export function getWhitelistInfo(params) {
  return post(`${WHITELIST}/orgWhiteListInfo`, params)
}

export function getWhiteListGlobalConfig(params) {
  return post(`${WHITELIST}/orgWhiteListGlobalConfig`, params)
}

export function getCloseWhiteList(params) {
  return post(`${WHITELIST}/whitelistCloseOrgList`, params)
}

export function getSoftwareList(params) {
  return post(`${WHITELIST}/getSoftwareInfo`, params)
}

export function getTerminalSoftDtl(params) {
  return post(`${WHITELIST}/orgInterceptSoftwareMessage`, params)
}
